import { render, staticRenderFns } from "./ReferenceColumn.vue?vue&type=template&id=13354124&scoped=true&"
import script from "./ReferenceColumn.vue?vue&type=script&lang=ts&"
export * from "./ReferenceColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13354124",
  null
  
)

export default component.exports